import { get } from "lodash"

export const getMenuItems = () => ([
  {
    id: "factorRisk",
    label: "Factor Risk",
    order: 0,
  },
])

export const getSelectedView = state => get(state, "modules.intradayRiskFactors.selectedView")
